module.exports = __webpack_public_path__ + "static/media/esm-logo.5dad1af3.svg";